import { FeatureFlags, Permission } from '@fabric-ui/components';
import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS } from '../../../../../../types';

const path = PAGE_PATHS.INCIDENTS;

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/threats/incidents/overview/')({
  beforeLoad: ({ context, preload }) => {
    const allowedFFIncidentWorkflow = !!context.featureFlags[FeatureFlags.ShowThreatDashboard];
    const isAllowed = context.userPermissions.hasAllowedPermission({ path, permission: Permission.READ }) && allowedFFIncidentWorkflow;
    context.validatePermissions({ isAllowed, preload });
  },
});
